import { extend } from 'vee-validate';
import { PaymentCardValidator } from '../utilities';

extend('card_cvv', {
    validate(value, { cardNumber }: any) {
        return PaymentCardValidator.validateCvv(value, cardNumber);
    },
    params: ['cardNumber']
});
